module.exports = __webpack_public_path__ + "static/media/img1-2.2db4cc42.png";